import React from "react";
import ConfirmationIcon from "../../../static/images/confirmation.svg";
import ErrorIcon from "../../../static/images/error.svg";
import InformationIcon from "../../../static/images/information.svg";
import WarningIcon from "../../../static/images/warning.svg";
import { Button as DlgButton, DlgRes, DlgType } from "../Tools/ProjectX";

export const icons: Record<DlgType, React.ReactNode> = {
  [DlgType.Warning]: <img src={WarningIcon} alt="Warning Icon" />,
  [DlgType.Error]: <img src={ErrorIcon} alt="Error Icon" />,
  [DlgType.Information]: <img src={InformationIcon} alt="Information Icon" />,
  [DlgType.Confirmation]: <img src={ConfirmationIcon} alt="Confirmation Icon" />,
};
export const buttonConfig = [
  { condition: DlgButton.Ok, label: "ОК", value: DlgRes.Ok },
  { condition: DlgButton.Yes, label: "Да", value: DlgRes.Yes },
  { condition: DlgButton.No, label: "Нет", value: DlgRes.No },
  { condition: DlgButton.Abort, label: "Прервать", value: DlgRes.Abort },
  { condition: DlgButton.Retry, label: "Повторить", value: DlgRes.Retry },
  { condition: DlgButton.Ignore, label: "Пропустить", value: DlgRes.Ignore },
  { condition: DlgButton.All, label: "Для всех", value: DlgRes.All },
  { condition: DlgButton.NoToAll, label: "Нет для всех", value: DlgRes.NoToAll },
  { condition: DlgButton.YesToAll, label: "Да для всех", value: DlgRes.YesToAll },
  { condition: DlgButton.Cancel, label: "Отмена", value: DlgRes.Cancel },
];
